export function hashId() {
  let cryptoObj = null
  if (import.meta.client) {
    cryptoObj = window !== undefined ? window.crypto : null
  }
  const array = new Uint32Array(2)
  if (cryptoObj) {
    cryptoObj.getRandomValues(array)
    return array[0].toString(36) + array[1].toString(36)
  } else {
    return ''
  }
}

export function luId(): string {
  return Math.random().toString(36).substring(2, 9)
}
